import TransitionTree from '@/classes/TransitionTree/TransitionTree'

export default () => ({
  transitionTree: new TransitionTree(),
  videoTransitionDownloadManager: null,
  imageUrlToSpriteClipMap: {},
  spritesReady: false,
})
